import React, { useState, useEffect, useMemo } from "react";
import { Typography, Grid, TextField, Box } from "@mui/material";
import CustomTable from "components/TableExplanded/Table";
import CustomPagination from "components/TableExplanded/Pagination";
import useProductData from "pages/Pawn/List/Bin/data/data";
import useColumns from "pages/Pawn/List/Bin/columns/mainColumns";
import useColumnsTwo from "pages/Pawn/List/Bin/columns/subColumns";
import Modal from "components/Modal/Pawn/Create/ModalInterest";
import ViewModal from "components/Modal/Pawn/View/ViewBuyItems";
import SearchBar from "components/TableExplanded/SearchBar";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SaveIcon from "@mui/icons-material/Save";

import {
  GradientButton,
  GradientButtonOutline,
} from "components/GradientButton";
import api from "_api";
import { Search } from "@mui/icons-material";

const Bin = ({ className }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [selectedProduct, setProduct] = useState(null);
  const [viewProduct, setViewProduct] = useState(null);
  const [fetchData, setFetchData] = useState();
  const [searchQuery, setSearchQuery] = useState(""); // Store the search query
  const [dataLength, setDataLength] = useState(0);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    totalPages: 0,
  });
  const [filter, setFilter] = useState({
    search: "",
    searchIdcard: "",
    searchName: "",
    searchDate: "",
  });

  const fetchProductData = async (clear_filter = false) => {
    try {
      const { data, isStatus, limit, total, page, totalPages } =
        await api.pawn.getTrash({
          ...(!clear_filter && filter),
          page: pagination.page,
          limit: pagination.limit,
        });
      console.log("data", data);
      if (isStatus) {
        setFetchData(data);
        setDataLength(total); // Set the total data length for pagination
        setPagination({ page, limit, totalPages });
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  };

  const ReuseOrder = async (values) => {
    try {
      const chageStatusOrder = await api.pawn.ReuseOrder(values);
      // console.log("data", values);
      if (chageStatusOrder) fetchProductData();
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  };

  useEffect(() => {
    fetchProductData();
  }, [pagination.page, pagination.limit]);

  // console.log("data display new data", fetchData);

  const handleModalOpen = () => {
    setModalOpen(!isModalOpen);
    if (selectedProduct && isModalOpen) setProduct(null);
  };

  const handleViewOpen = () => {
    setViewModalOpen(!isViewModalOpen);
    if (viewProduct && isViewModalOpen) setViewProduct(null);
  };

  const data = useProductData(fetchData);
  const columns = useColumns(
    setViewProduct,
    setProduct,
    handleViewOpen,
    handleModalOpen,
    ReuseOrder
  );
  const columnsInside = useColumnsTwo();
  const visibleColumns = columns.filter((col) => col.showInFilter);

  const filteredData = useMemo(() => {
    if (!searchQuery) return data; // If no search query, return all data

    return data.filter((row) => {
      return visibleColumns.some((column) => {
        const cellValue = row[column.accessor]?.toString()?.toLowerCase();
        return cellValue && cellValue.includes(searchQuery.toLowerCase());
      });
    });
  }, [data, searchQuery, visibleColumns]);

  // const handleSearchChange = (event) => {
  //   // Check if event.target and event.target.value are defined
  //   if (
  //     event &&
  //     event.target &&
  //     event.target.value !== undefined &&
  //     event.target.value !== null
  //   ) {
  //     setSearchTerm(event.target.value.toLowerCase());
  //     setSearchQuery(event.target.value);
  //   } else {
  //     console.error("Event target or value is undefined");
  //   }
  //   setPage(0);
  // };

  // const handleClear = () => {
  //   setSearchTerm("");
  //   setPage(0);
  //   setPagination((prev) => ({
  //     ...prev,
  //     page: 1,
  //   }));
  //   // fetchProductData({ search: "", page: 1, limit: pagination.limit || 10 });
  // };

  const handlePageChange = (event, newPage) => {
    setPagination((prev) => ({
      ...prev,
      page: newPage + 1,
    }));
  };

  const handleRowsPerPageChange = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    setPagination((prev) => ({
      ...prev,
      limit: newLimit,
      page: 1,
    }));
  };

  const handleSubmitSearch = () => {
    setPagination((prev) => ({
      ...prev,
      page: 1,
    }));
    fetchProductData();
  };

  return (
    <div className={className}>
      <Grid container spacing={2} style={{ marginBottom: "16px" }}>
        <Grid
          item
          xs={12}
          sm={12}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography component="div" style={{ fontSize: "32px" }}>
            ถังขยะ
          </Typography>
        </Grid>
      </Grid>
      {/* 
      <SearchBar
        columns={columns}
        searchTerm={setSearchTerm}
        visibleColumns={visibleColumns} // กรองคอลัมน์ที่ต้องการแสดง
        handleSearchChange={handleSearchChange}
        handleClear={handleClear}
        fetchData={fetchData}
        QRCode={false}
      /> */}

      <Grid
        container
        spacing={2}
        sx={{
          mb: 2,
        }}
      >
        <Grid item xs={12} sm={6} md={4}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs={3}>
              <Typography
                sx={{
                  fontSize: "16px",
                  whiteSpace: "nowrap",
                }}
              >
                รหัสรายการ
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="รหัสรายการ"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    bgcolor: "white",
                    height: "40px",
                  },
                }}
                value={filter.search}
                onChange={(e) => {
                  setFilter((prev) => ({
                    ...prev,
                    search: e.target.value,
                  }));
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs={3}>
              <Typography
                sx={{
                  fontSize: "16px",
                  whiteSpace: "nowrap",
                }}
              >
                เลขบัตรประชาชน
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="เลขบัตรประชาชน"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    bgcolor: "white",
                    height: "40px",
                  },
                }}
                value={filter.searchIdcard}
                onChange={(e) => {
                  setFilter((prev) => ({
                    ...prev,
                    searchIdcard: e.target.value,
                  }));
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs={3} textAlign={"right"}>
              <Typography
                sx={{
                  fontSize: "16px",
                  whiteSpace: "nowrap",
                }}
              >
                ชื่อ-สกุล
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="ชื่อ-สกุล"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    bgcolor: "white",
                    height: "40px",
                  },
                }}
                value={filter.searchName}
                onChange={(e) => {
                  setFilter((prev) => ({
                    ...prev,
                    searchName: e.target.value,
                  }));
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          mb: 2,
          gap: 2,
        }}
      >
        <GradientButtonOutline
          onClick={() => {
            setFilter({
              search: "",
              searchIdcard: "",
              searchName: "",
              searchDate: "",
            });
            fetchProductData(true);
          }}
          sx={{
            px: 3,
            display: "flex",
            alignItems: "center",
            height: "40px",
          }}
        >
          <Typography style={{ marginRight: "8px" }}>ล้าง</Typography>
        </GradientButtonOutline>
        <GradientButton
          onClick={handleSubmitSearch}
          sx={{
            px: 3,
            display: "flex",
            alignItems: "center",
            height: "40px",
          }}
          endIcon={<Search />}
        >
          <Typography style={{ marginRight: "8px" }}>ค้นหา</Typography>
        </GradientButton>
      </Box>

      <CustomTable
        columns={columns}
        columnsInside={columnsInside}
        searchTerm={searchTerm}
        data={filteredData}
        page={pagination.page}
        rowsPerPage={pagination.limit}
        setDataLength={setDataLength}
      />
      <CustomPagination
        totalPage={pagination.totalPages}
        page={pagination.page - 1 || 0}
        rowsPerPage={pagination.limit}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <Modal
        open={isModalOpen}
        onClose={handleModalOpen}
        selectedProduct={selectedProduct}
        fetchProductData={fetchProductData}
      />

      <ViewModal
        open={isViewModalOpen}
        onClose={handleViewOpen}
        selectedProduct={viewProduct}
      />
    </div>
  );
};

export default Bin;
